var shadeInfo = [
    {
        shade: "cream-beige",
        color: "ebbdaf",
        image: "https://cdn.shopify.com/s/files/1/0247/5376/6482/products/cream_beige_fs_500x500.jpg",
        link: "https://bovanticosmetics.com/collections/foundation/products/foundation-stick?variant=29529107529810",
        product: "flawless"
    },
    {
        shade: "tender-beige",
        color: "f2d4ac",
        image: "https://cdn.shopify.com/s/files/1/0247/5376/6482/products/tender_beige_fs_500x500.jpg",
        link: "https://bovanticosmetics.com/collections/foundation/products/foundation-stick?variant=29535134679122",
        product: "flawless"
    },
    {
        shade: "almond",
        color: "e2b88a",
        image: "https://cdn.shopify.com/s/files/1/0247/5376/6482/products/almond_fs_500x500.jpg",
        link: "https://bovanticosmetics.com/collections/foundation/products/foundation-stick?variant=29529107562578",
        product: "flawless"
    },
    {
        shade: "sandy-beige",
        color: "deaf79",
        image: "https://cdn.shopify.com/s/files/1/0247/5376/6482/products/golden_beige_fs_500x500.jpg",
        link: "https://bovanticosmetics.com/collections/foundation/products/foundation-stick?variant=29529107595346",
        product: "flawless"
    },
    {
        shade: "golden-honey",
        color: "ac7546",
        image: "https://cdn.shopify.com/s/files/1/0247/5376/6482/products/golden_beige_fs_500x500.jpg",
        link: "https://bovanticosmetics.com/collections/foundation/products/foundation-stick?variant=29529107628114",
        product: "flawless"
    },
    {
        shade: "golden-beige",
        color: "b48050",
        image: "https://cdn.shopify.com/s/files/1/0247/5376/6482/products/warm_tan_fs_500x500.jpg",
        link: "https://bovanticosmetics.com/collections/foundation/products/foundation-stick?variant=29529107660882",
        product: "flawless"
    },
    {
        shade: "brown-sugar",
        color: "b17732",
        image: "https://cdn.shopify.com/s/files/1/0247/5376/6482/products/spice_fs_500x500.jpg",
        link: "https://bovanticosmetics.com/collections/foundation/products/foundation-stick?variant=29529107693650",
        product: "flawless"
    },
    {
        shade: "rich-bronze",
        color: "a0713c",
        image: "https://cdn.shopify.com/s/files/1/0247/5376/6482/products/rich_bronze_fs_500x500.jpg",
        link: "https://bovanticosmetics.com/collections/foundation/products/foundation-stick?variant=29529107726418",
        product: "flawless"
    },
    {
        shade: "cocoa",
        color: "74502b",
        image: "https://cdn.shopify.com/s/files/1/0247/5376/6482/products/Cocoa_fs_500x500.jpg",
        link: "https://bovanticosmetics.com/collections/foundation/products/foundation-stick?variant=29529107791954",
        product: "flawless"
    },
    {
        shade: "dark-coffee",
        color: "865a2b",
        image: "https://cdn.shopify.com/s/files/1/0247/5376/6482/products/Dark_coffee_fs_500x500.jpg",
        link: "https://bovanticosmetics.com/collections/foundation/products/foundation-stick?variant=29529107759186",
        product: "flawless"
    },
    {
        shade: "amaretto",
        color: "eebc9f",
        image: "https://cdn.shopify.com/s/files/1/0247/5376/6482/products/Amaretto_800x800@2x.jpg",
        link: "https://bovanticosmetics.com/collections/foundation/products/matte-finish-foundation?variant=32027102740562",
        product: "matte"
    },
    {
        shade: "deep-olive",
        color: "846948",
        image: "https://cdn.shopify.com/s/files/1/0247/5376/6482/products/Deep_Olive_800x800@2x.png",
        link: "https://bovanticosmetics.com/collections/foundation/products/matte-finish-foundation?variant=33138153881682",
        product: "matte"
    },
    {
        shade: "golden-olive",
        color: "ad9376",
        image: "https://cdn.shopify.com/s/files/1/0247/5376/6482/products/golden_olive_800x800@2x.png",
        link: "https://bovanticosmetics.com/collections/foundation/products/matte-finish-foundation?variant=33138157060178",
        product: "matte"
    },
    {
        shade: "egyptian-bronze",
        color: "ad7455",
        image: "https://cdn.shopify.com/s/files/1/0247/5376/6482/products/egyptian_bronze_800x800@2x.jpg",
        link: "https://bovanticosmetics.com/collections/foundation/products/matte-finish-foundation?variant=32027102773330",
        product: "matte"
    },
    {
        shade: "warm-cognac",
        color: "aa744c",
        image: "https://cdn.shopify.com/s/files/1/0247/5376/6482/products/warm_cognac_800x800@2x.jpg",
        link: "https://bovanticosmetics.com/collections/foundation/products/matte-finish-foundation?variant=32027102806098",
        product: "matte"
    },
    {
        shade: "hazelnut",
        color: "ab784f",
        image: "https://cdn.shopify.com/s/files/1/0247/5376/6482/products/warm_cognac_800x800@2x.jpg",
        link: "https://bovanticosmetics.com/collections/foundation/products/matte-finish-foundation?variant=32027102838866",
        product: "matte"
    },
    {
        shade: "rich-kalua",
        color: "5a3925",
        image: "https://cdn.shopify.com/s/files/1/0247/5376/6482/products/rich_kahlua_800x800@2x.jpg",
        link: "https://bovanticosmetics.com/collections/foundation/products/matte-finish-foundation?variant=33138164334674",
        product: "matte"
    },
    {
        shade: "cream",
        color: "e4c5a1",
        image: "https://cdn.shopify.com/s/files/1/0247/5376/6482/products/Cream_Mineral_Powder_800x800@2x.jpg",
        link: "https://bovanticosmetics.com/collections/foundation/products/perfect-match-powder-foundation?variant=33138159059026",
        product: "powder"
    },
    {
        shade: "pecan",
        color: "d0a37f",
        image: "https://cdn.shopify.com/s/files/1/0247/5376/6482/products/Pecan_Powder_w_dust_800x800@2x.jpg",
        link: "https://bovanticosmetics.com/collections/foundation/products/perfect-match-powder-foundation?variant=29508707483730",
        product: "powder"
    },
    {
        shade: "tan",
        color: "d29c7c",
        image: "https://cdn.shopify.com/s/files/1/0247/5376/6482/products/Tan_Powder_dust_800x800@2x.jpg",
        link: "https://bovanticosmetics.com/collections/foundation/products/perfect-match-powder-foundation?variant=29529113755730",
        product: "powder"
    },
    {
        shade: "golden-tan",
        color: "c98a66",
        image: "https://cdn.shopify.com/s/files/1/0247/5376/6482/products/Golden_Tan_dust_800x800@2x.jpg",
        link: "https://bovanticosmetics.com/collections/foundation/products/perfect-match-powder-foundation?variant=29529113788498",
        product: "powder"
    },
    {
        shade: "amber",
        color: "bf8a71",
        image: "https://cdn.shopify.com/s/files/1/0247/5376/6482/products/Amber_Powder_dust_800x800@2x.jpg",
        link: "https://bovanticosmetics.com/collections/foundation/products/perfect-match-powder-foundation?variant=29529113821266",
        product: "powder"
    },
    {
        shade: "java",
        color: "b37155",
        image: "https://cdn.shopify.com/s/files/1/0247/5376/6482/products/Java_powder_dust_800x800@2x.jpg",
        link: "https://bovanticosmetics.com/collections/foundation/products/perfect-match-powder-foundation?variant=29529113854034",
        product: "powder"
    },
    {
        shade: "milk-chocolate",
        color: "a46d54",
        image: "https://cdn.shopify.com/s/files/1/0247/5376/6482/products/Milk_chocolate_800x800@2x.jpg",
        link: "https://bovanticosmetics.com/collections/foundation/products/perfect-match-powder-foundation?variant=29529113886802",
        product: "powder"
    }
  ];
  
  export default shadeInfo;